/**
 * Generate random hex id
 */
export const generateHexId = (bytes = 12) => {
  const array = crypto.getRandomValues(new Uint8Array(bytes))
  return Array.from(array, b => b.toString(16).padStart(2, '0')).join('')
}
